import { render, staticRenderFns } from "./shopJoinOrder.vue?vue&type=template&id=5b305d07&scoped=true&"
import script from "./shopJoinOrder.vue?vue&type=script&lang=js&"
export * from "./shopJoinOrder.vue?vue&type=script&lang=js&"
import style0 from "./shopJoinOrder.vue?vue&type=style&index=0&id=5b305d07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b305d07",
  null
  
)

export default component.exports